import {
  requestNotificationPermission,
  getFcmToken,
  deleteFcmToken,
  onForegroundMessage,
} from './fcm.service';
import { FcmContext, FcmMessageHandler } from './fcm.types';

class FcmManager {
  private static instance: FcmManager;
  private unsubscribe?: () => void;
  private token?: string | null;

  private constructor() { }

  static getInstance(): FcmManager {
    if (!FcmManager.instance) {
      FcmManager.instance = new FcmManager();
    }
    return FcmManager.instance;
  }

  async init(context?: FcmContext): Promise<string | null> {
    const granted = await requestNotificationPermission();
    if (!granted) return null;

    this.token = await getFcmToken();

    if (this.token) {
      this.registerToken(this.token, context);
    }

    return this.token;
  }

  listen(handler: FcmMessageHandler): void {
    if (this.unsubscribe) return;
    this.unsubscribe = onForegroundMessage(handler);

  }

  stop(): void {
    this.unsubscribe?.();
    this.unsubscribe = undefined;
  }

  async destroy(): Promise<void> {
    this.stop();
    await deleteFcmToken();
  }

  private registerToken(token: string, context?: FcmContext) {
    // 🔐 Send token to backend
    console.log('Register FCM token', { token, context });
  }
}

export const fcmManager = FcmManager.getInstance();
